import React from 'react';
import ReactDOM from 'react-dom/client';
import "./styles/style.css";
import App from './App';
import { NotFound } from './components/notFound/notFound';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { HeaderComponent } from './components/shared/headerComponent';
import { FooterComponent } from './components/shared/footerComponent';
import { About } from './components/about';
import { Contact } from './components/contact';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    errorElement: <NotFound />
  },
  {
    path: "/about",
    element: <About />,
    errorElement: <NotFound />
  },
  {
    path: "/franchisee",
    element: <Contact />,
    errorElement: <NotFound />
  }
]);

root.render(
  <React.StrictMode>
    <HeaderComponent />
    <RouterProvider router={router} />
    <FooterComponent />
  </React.StrictMode>
);
